<button [attr.data-btnId]="getElementId('openLandingEditModal')" type="button" (click)="open(content);" class="btn toolbar-btn">
  <i class="far fa-edit fa-lg"></i>
</button>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{'Edit landing page' | translate}}</h4>
    <button [attr.data-btnId]="getElementId('closeLandingEditModal')" type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <ngb-accordion [closeOthers]="true" activeIds="panel-0">
      <ngb-panel id="panel-0" title="Select visible tiles">
        <ng-template ngbPanelContent>
          <div class="list-group list-group-flush">
            <a *ngFor="let item of getAvailableTiles()" class="list-group-item list-group-item-action"
               (click)="toggleTileVisible(item)">
              <svg style="height: 1em; width: 1em;" *ngIf="isTileVisible(item.panel); else unchecked">
                <use xlink:href="#checked"></use>
              </svg>
              {{item.title}}
            </a>
          </div>
          <button [attr.data-btnId]="getElementId('revertLandingSetup')" class="btn btn-outline-warning" (click)="revertToDefault()">{{'Revert to default setup' | translate}}</button>
        </ng-template>
      </ngb-panel>
      <ngb-panel title="Load saved setup">
        <ng-template ngbPanelContent>
          <div class="list-group list-group-flush">
            <a *ngFor="let item of landingPages" class="list-group-item list-group-item-action"
               (click)="loadSavedSetup(item)">
              {{item.name}}
            </a>
          </div>
        </ng-template>
      </ngb-panel>
      <ngb-panel title="Save current setup">
        <ng-template ngbPanelContent>
          <form>
            <div class="form-group">
              <label for="name">{{'Name:' | translate}}</label>
              <input id="name" class="form-control form-control-sm" name="name" [(ngModel)]="landingPageSetup.name"
                     placeholder="{{'Name for new setup' | translate}}">
            </div>
            <button [attr.data-btnId]="getElementId('saveLandingPageSetup')"  type="button" class="btn btn-outline-primary" (click)="saveSetup()"><i class="far fa-save"></i>
            </button>
          </form>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>
</ng-template>

<ng-template #unchecked>
  <svg style="height: 1em; width: 1em;">
    <use xlink:href="#unchecked"></use>
  </svg>
</ng-template>

<i class="far fa-check-square" data-fa-symbol="checked"></i>
<i class="far fa-square" data-fa-symbol="unchecked"></i>
